/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResubmitRequestDto } from '../../models/resubmit-request-dto';
import { ResubmitResponseDto } from '../../models/resubmit-response-dto';

export interface IdpSubmissionResubmitPost$Params {
  body: ResubmitRequestDto;
}

export function idpSubmissionResubmitPost(http: HttpClient, rootUrl: string, params: IdpSubmissionResubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ResubmitResponseDto>> {
  const rb = new RequestBuilder(rootUrl, idpSubmissionResubmitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResubmitResponseDto>;
    })
  );
}

idpSubmissionResubmitPost.PATH = '/IdpSubmission/Resubmit';
